<template>
  <div :class="[navbarShow?'mt':'']">
    <div v-if="navbarShow" class="titlebar">
      <van-nav-bar
          :title="$route.name"
          left-text="返回"
          left-arrow
          @click-left="navback"
      >
        <template #right>
          <van-icon name="service-o" size="18" @click="goService()"/>
        </template>
      </van-nav-bar>
    </div>
    <!-- <div style="margin-top:100px">{{navbarShow}}</div> -->
    <loading v-show="loading"></loading>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script src="./dist/uplusapi.js"></script>
<script>
import { mapState } from 'vuex';
import loading from '@/components/loading.vue';
import UplusApi from '@uplus/uplus-api';
import { getUserTokens, getUserInfo, totalPoint, addMember } from '@/api/api';
import config from '@/config/config';
import utils from '@/utils/utils';
import { baseConfig } from '@hwork/tduck-form-generator';

export default {
  computed: {
    ...mapState(['loading']),
  },
  components: {
    loading,
  },
  provide() {
    const obj = {};
    Object.defineProperty(obj, 'initDeviceDone', {
      enumerable: true,
      get: () => this.initDeviceDone,
    });
    return {
      obj,
    };
  },
  data() {
    return {
      // showLoading:false,
      instance: new UplusApi(),
      active: 0,
      transitionName: 'slide-left',
      tabList: [
        { icon: 'wd-icon-bags', name: '首页', router: '/' },
        { icon: 'wd-icon-chat', name: '我的', router: '/mine' },
      ],
      timer: null,
      title: '海贝商城',
      extra: '',
      code: '',
      redirecturis: '',
      hbscToken: '',
      isAppEnv: false,
      appType: '',
      initDeviceDone: false,
      navbarShow: true,
      isAppEnvQuery: '',
    };
  },
  methods: {
    navback() {
      let this_ = this;
      let url = window.location.href;
      if (url.indexOf('source=2') > -1) {
        this_.instance.closeH5ContainerView();
      } else if (window.location.href == 'https://jf.haier.com/m/#/order?order=123456') {
        this.$router.go(-1);
      } else if (window.location.href == 'https://jf.haier.com/m/#/orders/search') {
        window.location.href = 'https://jf.haier.com/m/#/index2';
        return false;
      } else if (url.indexOf('#/index2') > -1 && this.isAppEnv) {
        this.$cookies.remove('hbscToken') == '';
        this.$cookies.remove('memberName') == '';
        this.$cookies.remove('memberId') == '';
        this.$cookies.remove('memberPhone') == '';
        this_.instance.closeH5ContainerView();
      } else {
        if (this.isAppEnv) {
          if (this.isAppEnvQuery === this.$route.path) {
            if (url.indexOf('/exchange') == -1) {
              this_.instance.closeH5ContainerView();
            }
          } else {
            window.history.back();
          }
        } else {
          window.history.back();
        }
      }
    },
    onChange(index) {
      this.$router.push(this.tabList[index].router);
    },
    waitMatomoInit() {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (this.$matomo) {
            clearInterval();
            resolve();
          }
        });
      });
    },

    async setUserId(userId) {
      await this.waitMatomoInit();
      this.$matomo.setUserId(userId);
    },
    async getUserInfo() {
      let params = {};
      const userInfo = await getUserInfo(params);
      if (userInfo.data) {
        this.$cookies.set('memberId', userInfo.data.idsUserId);
        sessionStorage.setItem('memberId', userInfo.data.idsUserId);
        this.$cookies.set('memberName', userInfo.data.loginName);
        sessionStorage.setItem('memberName', userInfo.data.loginName);
        this.$cookies.set('memberPhone', userInfo.data.cellphoene);
        sessionStorage.setItem('memberPhone', userInfo.data.cellphoene);
        const {
          BASE_URL,
          FORM_USER_NAME,
          FORM_USER_ID,
          FORM_USER_TOKEN,
          FORM_USER_PHONE,
          FORM_USER_SOURCE
          // ACCESS_TOKEN
        } = baseConfig;
        var hbscToken = this.$cookies.get('hbscToken') || sessionStorage.getItem('hbscToken');
        localStorage.setItem(FORM_USER_SOURCE, 'ZJ_APPLET');
        localStorage.setItem(FORM_USER_NAME, userInfo.data.loginName);
        localStorage.setItem(FORM_USER_ID, userInfo.data.idsUserId);
        localStorage.setItem(FORM_USER_PHONE, userInfo.data.cellphoene);
        localStorage.setItem(FORM_USER_TOKEN, hbscToken);
        this.setUserId(userInfo.data.idsUserId);
        this.insertMember();
        this.initDeviceDone = true;
      }
    },
    async gioTrack(eventId) {
      let this_ = this;
      await this_.instance.initDeviceReady();
      return (
          this_.instance.upTraceModule &&
          this_.instance.upTraceModule.gioTrack &&
          this_.instance.upTraceModule.gioTrack({ eventId }).then((res) => {
            // alert("查看是否调通")
            // alert(res.retInfo);
          }, (err) => {
            console.log(res.retInfo);
          })
      );
    },
    goService() {
      let hbscToken = this.$cookies.get('hbscToken') || sessionStorage.getItem('hbscToken');
      let memberId = this.$cookies.get('memberId') || sessionStorage.getItem('memberId');
      if (hbscToken == null || memberId == null) {
        this.$toast('请登录智家app或者小程序');
      } else {
        if (this.appType === 'hrzj') {
          let str = utils.toService('zjapp', 'jfzx', 'cd0203', '积分商城', 'noUrl');
          this.instance.upVdnModule.goToPageForResult({
            url: `mpaas://CustomerService/?${str}#/zhijia`,
          }).then((res) => {
            console.log('result', res);
          }, (err) => {
            console.log('err', err);
          });
        } else {
          let str = utils.toService('zjapp', 'jfzx', 'cd0203', '积分商城');
          location.href = config.serviceUrl + str;
        }
      }
    },
    appint() {
      let url = window.location.href;
      let code = url.match(/code=(\S*)&/);
      this.code = code[1];
      if (this.$cookies.get('hbscToken') == null && code !== null) {
        this.code = code[1];
        if (url != null && url.indexOf('redirect_uri') > -1) {
          let redirecturi = url.match(/redirect_uri=(\S*)/);
          this.redirecturis = decodeURIComponent(redirecturi[1]);
          if (this.redirecturis.indexOf('/m/') > -1) {
            this.redirecturis = this.redirecturis.match(/(\S*)&code/)[1];
            this.getUserToken();
          } else {
            window.location.href = this.redirecturis;
          }
        } else {
          this.getUserToken();
        }
      } else {
        if (url != null && url.indexOf('redirect_uri') > -1) {
          let redirecturi = url.match(/redirect_uri=(\S*)&code/);
          this.redirecturis = decodeURIComponent(redirecturi[1]);
          window.location.href = this.redirecturis;
        } else {
          this.getUserToken();
        }
      }
    },
    async getUserToken() {
      let params = {
        code: this.code,
        redirectUrL: this.redirecturis,
      };
      const res = await getUserTokens(params);
      if (res.code == '0000') {
        if (res.result) {
          var hbscToken = res.result || '';
          this.$cookies.set('hbscToken', hbscToken);
          sessionStorage.setItem('hbscToken', hbscToken);
          this.getUserInfo();
          if (this.redirecturis !== '') {
            window.location.href = this.redirecturis;
          }
        }
      } else {
        console.log('无法获取token');
      }
    },
    // 添加用户会员
    async insertMember() {
      let params = {
        id: this.$cookies.get('memberId') || sessionStorage.getItem('memberId'),
        name: this.$cookies.get('memberName') || sessionStorage.getItem('memberName'),
        phone: this.$cookies.get('memberPhone') || sessionStorage.getItem('memberPhone'),
        status: 0,
        sex: 0,
      };
      const res = await addMember(params);
    },
    qs(search) {
      return search.split('&').reduce((res, cur) => {
        const arr = cur.split('=');
        return Object.assign({ [arr[0]]: arr[1] }, res);
      }, {});
    },
  },
  watch: {
    $route(to, from) {
      //页面切换动画
      if (to.meta.index < from.meta.index) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
    },
  },
  mounted() {
    const {
      BASE_URL,
      FORM_USER_NAME,
      FORM_USER_ID,
      FORM_USER_TOKEN,
      FORM_USER_PHONE,
      FORM_USER_SOURCE
      // ACCESS_TOKEN
    } = baseConfig;

    // 海尔智家app        ZJ
    // 天蛛小程序        TZ_APPLET
    // 海尔智家公众号        ZJ_OFFICIAL_ACCOUNT
    // 短信        SMS
    // 海尔服务小程序        HAIER_APPLET
    // 海尔智家小程序        ZJ_APPLET
    // 海尔服务公众号        HAIER_OFFICIAL
    const self = this;
    let url = window.location.href;
    const userAgent = navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf('micromessenger') > -1) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          self.navbarShow = false;
        } else {
          //在微信中
          console.log('在微信中');
        }
      });
    }
    if (navigator.userAgent.indexOf('AliApp') > -1) {
      self.navbarShow = false;
    }
    if (userAgent.includes('uplus')) {
      // app环境--智家
      this.isAppEnv = true;
      this.appType = 'hrzj';
    } else if (userAgent.includes('sybird')) {
      // app环境--三翼鸟
      this.isAppEnv = true;
      this.appType = 'syn';
    }
    if (this.$store.state.showtip == true) {
      this.gioTrack('MB15992');
    }
    //如果没有token，调用智获取token
    //如果有token，不做操作
    if (this.isAppEnv) {
      this.$cookies.remove('hbscToken');
      this.$cookies.remove('memberName');
      this.$cookies.remove('memberId');
      this.$cookies.remove('memberPhone');
      sessionStorage.removeItem('hbscToken');
      sessionStorage.removeItem('memberId');
      sessionStorage.removeItem('memberName');
      sessionStorage.removeItem('memberPhone');
      this.isAppEnvQuery = this.$route.path;
      this.instance.initDeviceReady().then(function () {
        self.instance.upUserModule.getUserInfo().then((res) => {
          if (res.retData) {
            sessionStorage.setItem('hbscToken', res.retData.user_center_access_token);
            sessionStorage.setItem('memberId', res.retData.offUserId);
            sessionStorage.setItem('memberName', res.retData.nickname);
            sessionStorage.setItem('memberPhone', res.retData.phoneNumber);
            self.$cookies.set('hbscToken', res.retData.user_center_access_token);
            self.$cookies.set('memberId', res.retData.offUserId);
            self.$cookies.set('memberName', res.retData.nickname);
            self.$cookies.set('memberPhone', res.retData.phoneNumber);
            self.setUserId(res.retData.offUserId);
            localStorage.setItem(FORM_USER_SOURCE, 'ZJ');
            localStorage.setItem(FORM_USER_NAME, res.retData.nickname);
            localStorage.setItem(FORM_USER_ID, res.retData.offUserId);
            localStorage.setItem(FORM_USER_TOKEN, res.retData.user_center_access_token);
            localStorage.setItem(FORM_USER_PHONE, res.retData.phoneNumber);
            self.insertMember();
          }
          self.initDeviceDone = true;
        });
      });
    } else if (url.indexOf('Integralcard') > -1) {
      // alert("进入扫码激活页面")
    } else {
      let url = window.location.href;
      if (url != null && url.indexOf('code') > -1 && url.indexOf('submitOrder') < 0) {
        this.appint();
      } else if (url != null && url.indexOf('access_token') > -1 && url.indexOf('submitOrder') < 0) {
        this.$cookies.remove('hbscToken');
        this.$cookies.remove('memberName');
        this.$cookies.remove('memberId');
        this.$cookies.remove('memberPhone');
        sessionStorage.removeItem('hbscToken');
        sessionStorage.removeItem('memberId');
        sessionStorage.removeItem('memberName');
        sessionStorage.removeItem('memberPhone');
        const search = window.location.href.replace('#/index2', '').split('?');
        let token = this.qs(search[1]).access_token;
        if (token) {
          this.$cookies.set('hbscToken', token);
          sessionStorage.setItem('hbscToken', token);
          this.getUserInfo();
        }
      } else {
        this.getUserInfo();
      }
    }
  },
};
</script>

<style lang="scss">
body, html {
  height: auto;
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all ease 300ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.slide-left-leave-to {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.titlebar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
}

.mt {
  margin-top: 90px;
}
</style>
